<template>
  <v-main>
    <v-container fluid class="mt-16">
      <v-card
        flat
        outlined
        class="mx-auto"
        rounded="lg"
        max-width="500px"
        height="200px"
      >
        <v-row class="mt-5">
          <v-col cols="12">
            <div class="text-h5 text-center">Please wait</div>
          </v-col>
          <v-col cols="12">
            <v-row justify="center">
              <v-col cols="5" sm="4" class="d-flex align-center">
                <div class="text-body">Verifying account</div>
              </v-col>
              <v-col cols="1">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="mx-auto"
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'ValidateUser',
  data: () => ({
    temp: null,
  }),
  mounted() {
    this.$store.commit('updateValidationGuid', this.$route.params.guid);
    this.$store.dispatch('validateEmail');
  },
};
</script>

<style lang="scss" scoped>

</style>
